'use strict';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import './index.scss';
export default class Loading extends React.Component<any, any> {

    public componentDidMount() {
        document.body.style.overflow = 'hidden';
    }
    public componentWillUnmount() {
        document.body.style.overflow = '';
    }

    public render() {
        return (
            <div className="chj-bussiness-loading">
                <div>
                    <i className="loading-icon"></i>
                    <p>加载中...</p>
                </div>
            </div>
        );
    }
}

function getWrap(): HTMLElement {
    const wrapId = 'loading-wrap';
    let wrap = document.getElementById(wrapId);
    if (!wrap) {
        wrap = document.createElement('div');
        wrap.setAttribute('id', wrapId);
        document.body.appendChild(wrap);
    }
    return wrap;
}

export function showLoading() {
    ReactDOM.render(
        <Loading />,
        getWrap(),
    );
}

export function hideLoading() {
    ReactDOM.unmountComponentAtNode(getWrap());
}
